import { render, staticRenderFns } from "./DomainFinder.vue?vue&type=template&id=5883028b"
import script from "./DomainFinder.vue?vue&type=script&lang=js"
export * from "./DomainFinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports